import { getCookie } from 'cookies-next'
import type { GetServerSidePropsContext, NextApiRequest, NextApiResponse } from 'next'

import { APP_ENV, OPERATIONS_SERVICE, PERSONALIZATION_SERVICE } from '@/config/env'
import { AUTH_COOKIE_NAME } from '@/server/routers/flows/utils/cookies'
import Api from '@api-service/api'
import { getServiceUrlBases } from '@api-service/api/utils'
import type { Language } from '@constants/format'

const protocol = 'https://'
const apiDomain: string = APP_ENV !== 'production' ? 'api.gtsf.insure' : 'api.getsafe.eu'

export const apiBases = Object.freeze({
  user: `${protocol}user-service.${apiDomain}/api`,
  insurance: `${protocol}insurance-service.${apiDomain}/api`,
  personalizationService: PERSONALIZATION_SERVICE,
  operationsService: OPERATIONS_SERVICE,
})

export const getApiService = ({
  req,
  res,
  language,
}: {
  language?: Language
  req?: NextApiRequest | GetServerSidePropsContext['req']
  res?: NextApiResponse | GetServerSidePropsContext['res']
}) => {
  const authToken = getCookie(AUTH_COOKIE_NAME, { req, res })
  return new Api({
    serviceUrlBases: getServiceUrlBases(apiBases),
    configGenerator: () => ({
      internalHeaders: {
        Authorization: authToken ? `Token token="${authToken}"` : '',
        'x-gtsf-content-language': language ?? '',
        'x-gtsf-api-client': 'web',
      },
    }),
  })
}
